'use client';

import React__default, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { IconArrowLeft, IconDeleteGrey } from '../icons/index.js';
import s from './FormModal.module.css.js';

/* eslint-disable no-unused-vars */
var FormModal = function (props) {
    var _a = props.isOpen, isOpen = _a === void 0 ? false : _a, _b = props.children, children = _b === void 0 ? null : _b, title = props.title, _c = props.onBack, onBack = _c === void 0 ? function () { } : _c, onSave = props.onSave, onDelete = props.onDelete, submitFormId = props.submitFormId, isDisabledSaveBtn = props.isDisabledSaveBtn, langCode = props.langCode, closeText = props.closeText, textData = props.textData;
    var ANIMATION_DURATION = FormModal.ANIMATION_DURATION;
    var _d = useState(false), transforming = _d[0], setTransforming = _d[1];
    useEffect(function () {
        var body = document.getElementsByTagName('body')[0];
        if (isOpen) {
            // body.style.overflow = 'hidden'
            // body.style.touchAction = 'none'
            body.setAttribute('style', 'touch-action:none; -ms-touch-action: none; overflow: hidden; height: 100%; -webkit-overflow-scrolling: touch;');
            setTimeout(function () {
                setTransforming(true);
            }, 50);
        }
        else {
            setTimeout(function () {
                setTransforming(false);
                // body.style.overflow = ''
                // body.style.touchAction = 'auto'
                body.setAttribute('style', 'touch-action:auto; -ms-touch-action: auto; overflow: visible');
            }, ANIMATION_DURATION);
        }
        return function () {
            body.setAttribute('style', 'touch-action:auto; -ms-touch-action: auto; overflow: visible');
        };
    }, [isOpen]);
    if (!isOpen && !transforming)
        return null;
    var saveText = (textData === null || textData === void 0 ? void 0 : textData.saveText) ? textData === null || textData === void 0 ? void 0 : textData.saveText : langCode === 'vi' ? 'Lưu' : 'Save';
    var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
    if (!bodyNode) {
        return null;
    }
    return ReactDOM.createPortal(React__default.createElement("div", { className: "".concat(s.formModal, " ").concat(isOpen && transforming ? s.formModalOpened : null) },
        React__default.createElement("div", { className: s.header },
            React__default.createElement("div", { style: { cursor: 'pointer' }, onClick: function () { return onBack(); } },
                React__default.createElement(IconArrowLeft, { width: 30, height: 30 })),
            React__default.createElement("span", { className: s.title }, title),
            onDelete ? (React__default.createElement("div", { style: { cursor: 'pointer' }, onClick: function () { return onDelete(); } },
                React__default.createElement(IconDeleteGrey, { width: 30, height: 30 }))) : null),
        React__default.createElement("div", { className: s.body }, children),
        React__default.createElement("div", { className: s.footer },
            React__default.createElement("div", { className: "".concat(s.button, " ").concat(s.cancelBtn, " ").concat(!onSave && !submitFormId ? s.fullFlex : ''), onClick: function () { return onBack(); } }, closeText || (langCode === 'vi' ? 'Hủy' : 'Cancel')),
            onSave ? (React__default.createElement("div", { className: "".concat(s.button, " ").concat(s.saveBtn, " ").concat(isDisabledSaveBtn ? s.disabledBtn : ''), onClick: function () {
                    if (!isDisabledSaveBtn) {
                        onSave();
                    }
                } }, saveText)) : null,
            submitFormId && (React__default.createElement("button", { className: "".concat(s.button, " ").concat(s.saveBtn), form: submitFormId, type: 'submit' }, saveText)))), bodyNode);
};
FormModal.ANIMATION_DURATION = 400;

export { FormModal as default };
//# sourceMappingURL=index.js.map
